<div class="card mt-3" i18n-title title="Môj rozvrh, vyhľadávanie rozvrhu">
  <div class="card-header rozvrh d-flex flex-row justify-content-between" (click)="openRozvrh()">
    <div class="ais-color h6 title" i18n>Môj rozvrh, vyhľadávanie rozvrhu</div>
    <button i18n-title title="Môj rozvrh, vyhľadávanie rozvrhu" mat-mini-fab color="warn">
      <mat-icon>calendar_today</mat-icon>
    </button>
  </div>
</div>
